import React, { PureComponent } from 'react'
import ReactDOM from 'react-dom'

require('./bootstrap')

import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles/index'
import {
    amber,
    blue,
    blueGrey,
    brown,
    common,
    cyan,
    deepOrange,
    deepPurple,
    green,
    grey,
    indigo,
    lightBlue,
    lightGreen,
    lime,
    orange,
    pink,
    purple,
    red,
    teal,
    yellow
} from '@material-ui/core/colors'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons/faArrowAltCircleRight'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons/faShieldAlt'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch'
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons/faLongArrowAltLeft'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons/faLongArrowAltRight'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons/faCheckDouble'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons/faEllipsisV'
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons/faPaperPlane'
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload'
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { faGift } from '@fortawesome/free-solid-svg-icons/faGift'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { asIcon } from './fontAwesomeFree'
import QuestionApplication from './QuestionApplication'
import { getTheme, isValidTheme } from './QuestionApplicationWrapper.styles'
import ResultPage from './QuestionApplication/views/ResultPage'
import queryString from 'query-string'
import { fetchTheme } from './api'
import { CssBaseline } from '@material-ui/core'

// Free icons under the former Pro prefixes/names, see fontAwesomeFree.js
library.add(
    faArrowAltCircleRight,
    asIcon(faShieldAlt, 'far', 'shield-check'),
    asIcon(faCheck, 'far'),
    asIcon(faCircleNotch, 'far', 'spinner-third'),
    asIcon(faLongArrowAltLeft, 'far'),
    asIcon(faLongArrowAltRight, 'far'),
    asIcon(faChevronRight, 'far'),
    asIcon(faChevronDown, 'far'),
    asIcon(faStar, 'far', 'stars'),
    asIcon(faCheckDouble, 'fal'),
    asIcon(faEllipsisV, 'fal'),
    asIcon(faPaperPlane, 'fal'),
    asIcon(faUpload, 'fal'),
    faFileSignature,
    faStar,
    faLock,
    asIcon(faGift, 'fal'),
    faCheck,
    asIcon(faEnvelope, 'fal'),
    asIcon(faBars, 'far'),
    asIcon(faTimes, 'far')
)

const colors = {
    amber: amber,
    blue: blue,
    blueGrey: blueGrey,
    brown: brown,
    common: common,
    cyan: cyan,
    deepOrange: deepOrange,
    deepPurple: deepPurple,
    green: green,
    grey: grey,
    indigo: indigo,
    lightBlue: lightBlue,
    lightGreen: lightGreen,
    lime: lime,
    orange: orange,
    pink: pink,
    purple: purple,
    red: red,
    teal: teal,
    yellow: yellow
}

function bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false)
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler)
    }
}

class QuestionApplicationWrapper extends PureComponent {
    constructor(props) {
        super(props)

        bindEvent(window, 'message', e => {
            if (e.data === 'themeUpdated') {
                this.getThemeDraft()
            }
        })
    }

    state = {}

    componentWillMount() {
        const { data } = this.props
        this.setState({ theme: data.theme })
    }

    getThemeDraft = () => {
        const { theme } = this.state
        fetchTheme(theme, true).then(response => {
            isValidTheme(response.theme) && this.updateTheme(response.theme)
        })
    }

    updateTheme = newTheme => {
        const { theme } = this.state
        const pageRefreshNeededAttributes = ['primaryColor', 'headerFontFamily', 'bodyFontFamily', 'bodyBackground']
        for (let pageRefreshNeededAttribute of pageRefreshNeededAttributes) {
            if (theme[pageRefreshNeededAttribute] !== newTheme[pageRefreshNeededAttribute]) {
                window.location.reload()
                return
            }
        }
        this.setState({ theme: newTheme }, this.forceUpdate())
    }

    render() {
        const { data } = this.props
        const { theme } = this.state

        if (!data || !theme) {
            return null
        }

        const preview = !!preview
        const layout = theme.layout ? theme.layout : 'full'
        const minHeight = data.minHeight ? data.minHeight : null
        const muiTheme = getTheme(theme)

        if (!muiTheme) {
            return null
        }

        return (
            <>
                <ScopedCssBaseline className={'baseline'}>
                    <div className="App">
                        <MuiThemeProvider theme={muiTheme}>
                            {data.resultPage ? (
                                <ResultPage resultPage={data.resultPage} />
                            ) : preview ? (
                                <>
                                    {data.questionPages.map((questionPage, key) => {
                                        return <QuestionApplication data={questionPage} />
                                    })}
                                </>
                            ) : (
                                <QuestionApplication data={data} layout={layout} theme={theme} key={'questionApp'} minHeight={minHeight} />
                            )}
                        </MuiThemeProvider>
                    </div>
                </ScopedCssBaseline>
            </>
        )
    }
}

function getSettingsObject() {
    const settings = {}
    if (typeof _lsq !== 'undefined') {
        for (let value of _lsq) {
            settings[value[0]] = value[1]
        }
    }
    return settings
}

function importStyles(url) {
    var css = document.createElement('link')
    css.rel = 'stylesheet'
    css.type = 'text/css'
    css.href = url
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(css, s)
}

const settings = getSettingsObject()
const element = document.getElementById('questionApplication')

if (settings && element && settings._container && settings._theme) {
    //TODO: Move this embedded related code to different file.

    const protocol = 'https:' === document.location.protocol ? 'https://' : 'http://'
    importStyles(protocol + 'uusi.kilpailu.fi/css/questionApplication.css?v=' + +new Date())
    importStyles(protocol + 'uusi.kilpailu.fi/aq/styles?theme=' + settings._theme)

    axios
        .post(('https:' === document.location.protocol ? 'https://' : 'http://') + 'api.kilpailu.fi/aq/embedded', {
            container: settings._container,
            theme: settings._theme,
            affiliate: settings._affiliate
        })
        .then(res => {
            const data = res.data
            if (!data || !data.questionContainer || !data.theme) {
                return
            }
            ReactDOM.render(
                <QuestionApplicationWrapper
                    data={{
                        questionContainerId: data.questionContainer.id,
                        theme: data.theme,
                        affiliateTag: data.affiliateTag
                    }}
                />,
                element
            )
        })
}

window.autoQuestionApplication = data => {
    ReactDOM.render(<QuestionApplicationWrapper data={data} />, document.getElementById('questionApplication'))
}
